import request from '@/utils/requestJxsDd'
import {getUserInfo} from '@/utils/common'
import requestExcel from '@/utils/requestExcel'


// 获取员工角色列表
export const list = (data) => {
    const userInfo = getUserInfo()
    return request('/jxs/JxsXsdd/list', {
        method: 'post',
        data: {
            ...data,
            jxsid: userInfo.jxsid
        }
    })
}
// 获取员工角色列表
export const xdtz = (data) => {
    const userInfo = getUserInfo()
    return request('/jxs/JxsXsdd/xdtz', {
        method: 'post',
        data: {
            ...data,
            jxsid: userInfo.jxsid
        }
    })
}

// 获取员工角色新增和编辑
export const saveOrUpdate = (data) => {
    const userInfo = getUserInfo()
    return request('/jxs/JxsXsdd/save', {
        method: 'post',
        data: {
            ...data,
            jxsid: userInfo.jxsid
        }
    })
}
// 获取员工角色新增和编辑
export const submit = (data) => {
    const userInfo = getUserInfo()
    return request('/jxs/JxsXsdd/submit', {
        method: 'post',
        data: {
            ...data,
            jxsid: userInfo.jxsid
        }
    })
}
// 获取员工角色新增和编辑
export const cancel = (data) => {
    const userInfo = getUserInfo()
    return request('/jxs/JxsXsdd/cancel', {
        method: 'post',
        data: {
            ...data,
            jxsid: userInfo.jxsid
        }
    })
}
// 获取员工角色新增和编辑
export const back = (data) => {
    const userInfo = getUserInfo()
    return request('/jxs/JxsXsdd/back', {
        method: 'post',
        data: {
            ...data,
            jxsid: userInfo.jxsid
        }
    })
}

// 审核
export const auditOk = (data) => {
    const userInfo = getUserInfo()
    return request('/jxs/JxsXsdd/auditOk', {
        method: 'post',
        data: {
            ...data,
            jxsid: userInfo.jxsid
        }
    })
}
export const auditNo = (data) => {
    const userInfo = getUserInfo()
    return request('/jxs/JxsXsdd/auditNo', {
        method: 'post',
        data: {
            ...data,
            jxsid: userInfo.jxsid
        }
    })
}
// 获取员工角色详情
export const detail = (data) => {
    const userInfo = getUserInfo()
    return request('/jxs/JxsXsdd/detail', {
        method: 'post',
        data: {
            ...data,
            jxsid: userInfo.jxsid
        }
    })
}
// 获取员工角色详情
export const getXdxx = (data) => {
    const userInfo = getUserInfo()
    return request('/jxs/JxsXsdd/getXdxx', {
        method: 'post',
        data: {
            ...data,
            jxsid: userInfo.jxsid
        }
    })
}
// 获取员工角色详情
export const getDdmxWithKc = (data) => {
    const userInfo = getUserInfo()
    return request('/jxs/JxsXsdd/getDdmxWithKc', {
        method: 'post',
        data: {
            ...data,
            jxsid: userInfo.jxsid
        }
    })
}


// 获取员工角色列表
export const selectCkcp = (data) => {
    const userInfo = getUserInfo()
    return request('/jxs/JxsXsdd/selectCkcp', {
        method: 'post',
        data: {
            ...data
        }
    })
}
// 获取员工角色列表
export const selectCkcpFxs = (data) => {
    const userInfo = getUserInfo()
    return request('/jxs/JxsXsdd/selectCkcpFxs', {
        method: 'post',
        data: {
            ...data
        }
    })
}
// 获取员工角色列表
export const selectCkcpQt = (data) => {
    const userInfo = getUserInfo()
    return request('/jxs/JxsXsdd/selectCkcpQt', {
        method: 'post',
        data: {
            ...data
        }
    })
}


// 获取员工角色列表
export const wxck = (data) => {
    const userInfo = getUserInfo()
    return request('/jxs/JxsXsdd/wxck', {
        method: 'post',
        data: {
            ...data
        }
    })
}
// 获取员工角色列表
export const exportXsdd = (data) => {
    const userInfo = getUserInfo()
    return requestExcel('/xsdddt/list', {
        method: 'post',
        data: {
            ...data,
            jxsid: userInfo.jxsid
        }
    })
}
// 获取员工角色列表
export const exportMsdd = (data) => {
    const userInfo = getUserInfo()
    return requestExcel('/msdddt/list', {
        method: 'post',
        data: {
            ...data,
            jxsid: userInfo.jxsid
        }
    })
}

// 获取员工角色详情
export const getCpxxLast = (data) => {
    const userInfo = getUserInfo()
    return request('/jxs/JxsXsdd/getCpxxLast', {
        method: 'post',
        data: {
            ...data,
            jxsid: userInfo.jxsid
        }
    })
}

// 基础资料中心 - 产品管理 -- 设置折扣率
export const list5Time = (data) => {
    const userInfo = getUserInfo()
    return request('/jxs/JxsXsdd/list5Time', {
        method: 'post',
        data: {
            ...data,
            jxsid: userInfo.jxsid
        }
    })
}
